/**
 * @module trend_rating_measurements
 */
import { createReducer } from '@reduxjs/toolkit';
import { trendsActions } from '~/behaviors/actions/trends.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const mergeRatingMeasurements = (state, action) => {
  const stats = action?.payload?.entities?.trendRatingMeasurements || {};

  // reset state to empty to prevent save entities represent same trend twice
  const newState = {};
  Object.values(stats).forEach((measurement) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    newState[measurement.id] = {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...newState[measurement.id],
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...measurement,
    };
  });
  return newState;
};

const trendRatingMeasurements = createReducer(defaultState, (builder) => {
  builder
    .addCase(metaActions.reset, reset)
    .addCase(accountActions.logout.pending, reset)
    .addCase(accountActions.switchCompany.pending, reset)
    .addCase(trendsActions.fetchTrendResults.fulfilled, mergeRatingMeasurements)
    .addCase(trendsActions.fetchContinuousSurveyTrendsAnalysis.fulfilled, mergeRatingMeasurements);
});

export default trendRatingMeasurements;
